import { render, staticRenderFns } from "./board_qna_view.vue?vue&type=template&id=6e17f9de&"
import script from "./board_qna_view.vue?vue&type=script&lang=js&"
export * from "./board_qna_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports